import script from "./SugestaoMelhoriaAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./SugestaoMelhoriaAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./SugestaoMelhoriaAdministrar.vue?vue&type=style&index=0&id=3157fe9f&scoped=true&lang=css"
import "./SugestaoMelhoriaAdministrar.vue?vue&type=style&index=1&id=3157fe9f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3157fe9f"]])

export default __exports__